module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * A color manipulation library useful for dynamically
 * mixing colors together.
 */

var color6Regexp = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;
var color3Regexp = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i;
var rgbaRegexp = /^rgba?\(\s*(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\s*\)$/i;

// Parse a color in #abcdef, rgb(...), or rgba(...) form into an object
// with r,g,b,a keys.
var parse = function parse(color) {
    if (typeof color !== "string") {
        throw new Error("Failed to parse color: " + color);
    }

    var color3Match = color.match(color3Regexp);
    if (color3Match) {
        return {
            r: parseInt("" + color3Match[1] + color3Match[1], 16),
            g: parseInt("" + color3Match[2] + color3Match[2], 16),
            b: parseInt("" + color3Match[3] + color3Match[3], 16),
            a: 1
        };
    }

    var color6Match = color.match(color6Regexp);
    if (color6Match) {
        return {
            r: parseInt(color6Match[1], 16),
            g: parseInt(color6Match[2], 16),
            b: parseInt(color6Match[3], 16),
            a: 1
        };
    }

    var rgbaMatch = color.match(rgbaRegexp);
    if (rgbaMatch) {
        return {
            r: parseFloat(rgbaMatch[1]),
            g: parseFloat(rgbaMatch[2]),
            b: parseFloat(rgbaMatch[3]),
            a: rgbaMatch[4] ? parseFloat(rgbaMatch[4]) : 1
        };
    }

    throw new Error("Failed to parse color: " + color);
};

// Stringify the color in an `rgba()` or `#abcdef` format.
var format = function format(color) {
    var r = Math.round(color.r);
    var g = Math.round(color.g);
    var b = Math.round(color.b);

    if (color.a === 1) {
        var _s = function _s(c) {
            var asString = c.toString(16);
            return asString.length === 1 ? asString + asString : asString;
        };
        return "#" + _s(r) + _s(g) + _s(b);
    } else {
        return "rgba(" + r + "," + g + "," + b + "," + color.a.toFixed(2) + ")";
    }
};

// Adjust the alpha value of a color.
var fade = exports.fade = function fade(color, percentage) {
    if (percentage < 0 || percentage > 1) {
        throw new Error("Percentage must be between 0 and 1");
    }
    var components = parse(color);
    return format(_extends({}, components, {
        a: components.a * percentage
    }));
};

// Mix a color into a background color, using the alpha channel of the base
// color to determine the linear blend.
var mix = exports.mix = function mix(color, background) {
    var colorObj = parse(color);
    var bgObj = parse(background);

    return format({
        r: colorObj.r * colorObj.a + bgObj.r * (1 - colorObj.a),
        g: colorObj.g * colorObj.a + bgObj.g * (1 - colorObj.a),
        b: colorObj.b * colorObj.a + bgObj.b * (1 - colorObj.a),
        a: bgObj.a
    });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fade = exports.mix = exports.SemanticColor = exports.default = undefined;

var _utils = __webpack_require__(0);

var offBlack = "#21242c";

var white = "#ffffff";

var Color = {
    // Product
    blue: "#1865f2",
    purple: "#9059ff",
    green: "#00a60e",
    gold: "#ffb100",
    red: "#d92916",

    // Neutral
    offBlack: offBlack,
    offBlack64: (0, _utils.fade)(offBlack, 0.64),
    offBlack50: (0, _utils.fade)(offBlack, 0.5),
    offBlack32: (0, _utils.fade)(offBlack, 0.32),
    offBlack16: (0, _utils.fade)(offBlack, 0.16),
    offBlack8: (0, _utils.fade)(offBlack, 0.08),

    offWhite: "#f7f8fa",
    white: white,
    white64: (0, _utils.fade)(white, 0.64),

    // Brand
    darkBlue: "#0a2a66",
    teal: "#00e5ae",
    lightBlue: "#37c5fd",
    pink: "#fa50ae"
};

var SemanticColor = {
    controlDefault: Color.blue,
    controlDestructive: Color.red
};

exports.default = Color;
exports.SemanticColor = SemanticColor;
exports.mix = _utils.mix;
exports.fade = _utils.fade;

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@khanacademy/wonder-blocks-color/index.js
// module id = 69
// module chunks = 0